import React, { useEffect, useState } from 'react';
import './SuccessModal.css';

export default function SuccessModal({
    show,
    onClose,
    title = "Success!",
    message = "Your account has been successfully created.",
    buttonText = "OK",
    icon = "fas fa-check-circle",
    subtitle = null
}) {
    const [animateIcon, setAnimateIcon] = useState(false);

    useEffect(() => {
        if (show) {
            // Trigger icon animation after modal shows
            setTimeout(() => setAnimateIcon(true), 100);
        } else {
            setAnimateIcon(false);
        }
    }, [show]);

    if (!show) return null;

    return (
        <>
            {/* Backdrop */}
            <div 
                className="modal-backdrop fade show" 
                onClick={onClose}
                style={{ zIndex: 1055 }}
            ></div>

            {/* Modal */}
            <div 
                className="modal fade show d-block"
                tabIndex="-1"
                aria-modal="true"
                role="dialog"
                style={{ zIndex: 1056 }}
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content success-modal-content border-0 shadow-lg">
                        {/* Close Button */}
                        <button 
                            type="button" 
                            className="btn-close position-absolute top-0 end-0 m-3" 
                            onClick={onClose}
                            aria-label="Close"
                            style={{ zIndex: 1 }}
                        ></button>

                        <div className="modal-body text-center p-5">
                            {/* Animated Success Icon */}
                            <div className="mb-4 position-relative">
                                <div className={`success-icon-wrapper ${animateIcon ? 'animate' : ''}`}>
                                    <div className="success-circle-bg"></div>
                                    <i className={`${icon} success-icon text-success`} 
                                       style={{ fontSize: '5rem', position: 'relative', zIndex: 2 }}>
                                    </i>
                                </div>
                            </div>

                            {/* Title */}
                            <h3 className="fw-bold mb-3" style={{ fontSize: '1.75rem' }}>
                                {title}
                            </h3>

                            {/* Subtitle (if provided) */}
                            {subtitle && (
                                <p className="text-muted mb-3" style={{ fontSize: '1rem' }}>
                                    {subtitle}
                                </p>
                            )}

                            {/* Message */}
                            <div className="success-message mb-4">
                                {typeof message === 'string' ? (
                                    <p className="text-muted mb-0" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
                                        {message}
                                    </p>
                                ) : (
                                    message
                                )}
                            </div>

                            {/* Action Button */}
                            <button
                                type="button"
                                className="btn BtnBlack py-3 px-5 mt-3"
                                onClick={onClose}
                                style={{ 
                                    minWidth: '200px',
                                    fontSize: '1rem',
                                    fontWeight: '500',
                                    borderRadius: '8px'
                                }}
                            >
                                {buttonText}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
